'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
//   1        2       3      4         5            6           7          8
//  888888  888888      88  88      8888888888  88                  88  8888888888
//  88          88      88  88      88  88      88  88          88  88      88  88
//  8888      8888    8888  8888    88          8888888888  8888888888          88
//  88          88      88  88
//  88          88  888888  888888
var EXIF_ORIENTATIONS = exports.EXIF_ORIENTATIONS = [{ op: 'none', radians: 0 }, { op: 'none', radians: 0 }, { op: 'flip-x', radians: 0 }, { op: 'none', radians: Math.PI }, { op: 'flip-y', radians: 0 }, { op: 'flip-x', radians: Math.PI / 2 }, { op: 'none', radians: Math.PI / 2 }, { op: 'flip-x', radians: -Math.PI / 2 }, { op: 'none', radians: -Math.PI / 2 }];

var isExifRotated = exports.isExifRotated = function isExifRotated(orientation) {
  return [5, 6, 7, 8].includes(orientation);
};

// Without rotation handling
var drawBasicImage = exports.drawBasicImage = function drawBasicImage(ctx, image, x, y, width, height) {
  var _ref = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {},
      _ref$objectFit = _ref.objectFit,
      objectFit = _ref$objectFit === undefined ? 'none' : _ref$objectFit,
      _ref$orientation = _ref.orientation,
      orientation = _ref$orientation === undefined ? 0 : _ref$orientation,
      _ref$offsetX = _ref.offsetX,
      offsetX = _ref$offsetX === undefined ? 1 / 2 : _ref$offsetX,
      _ref$offsetY = _ref.offsetY,
      offsetY = _ref$offsetY === undefined ? 1 / 2 : _ref$offsetY;

  var imageWidth = image.width;
  var imageHeight = image.height;
  // Resize values
  var resizeRatio = Math[objectFit === 'cover' ? 'max' : 'min'](width / imageWidth, height / imageHeight);
  var resizeWidth = imageWidth * resizeRatio;
  var resizeHeight = imageHeight * resizeRatio;
  // Cropping values
  var sWidth = imageWidth / (resizeWidth / width);
  var sHeight = imageHeight / (resizeHeight / height);
  var sX = (imageWidth - sWidth) * offsetX;
  var sY = (imageHeight - sHeight) * offsetY;
  // Draw image
  ctx.drawImage(image, sX, sY, sWidth, sHeight, x, y, width, height);
};

var drawImage = exports.drawImage = function drawImage(ctx, image, x, y, width, height) {
  var _ref2 = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {},
      _ref2$objectFit = _ref2.objectFit,
      objectFit = _ref2$objectFit === undefined ? 'cover' : _ref2$objectFit,
      _ref2$orientation = _ref2.orientation,
      orientation = _ref2$orientation === undefined ? 0 : _ref2$orientation,
      _ref2$offsetX = _ref2.offsetX,
      offsetX = _ref2$offsetX === undefined ? 1 / 2 : _ref2$offsetX,
      _ref2$offsetY = _ref2.offsetY,
      offsetY = _ref2$offsetY === undefined ? 1 / 2 : _ref2$offsetY;

  // Orientation value
  var rotation = EXIF_ORIENTATIONS[orientation].radians;
  var isHalfRotated = rotation !== 0 && rotation % Math.PI === 0;
  var isQuarterRotated = rotation !== 0 && rotation % (Math.PI / 2) === 0 && !isHalfRotated;
  var isRotatedClockwise = rotation / (Math.PI / 2) < 0; // @NOTE handle 2*PI rotation?
  // Size values
  var imageWidth = !isQuarterRotated ? image.width : image.height;
  var imageHeight = !isQuarterRotated ? image.height : image.width;
  // Resize values
  var resizeRatio = Math[objectFit === 'cover' ? 'max' : 'min'](width / imageWidth, height / imageHeight);
  var resizeWidth = !isQuarterRotated ? imageWidth * resizeRatio : imageHeight * resizeRatio;
  var resizeHeight = !isQuarterRotated ? imageHeight * resizeRatio : imageWidth * resizeRatio;
  // Cropping values
  var sWidth = !isQuarterRotated ? imageWidth / (resizeWidth / width) : imageHeight / (resizeWidth / height);
  var sHeight = !isQuarterRotated ? imageHeight / (resizeHeight / height) : imageWidth / (resizeHeight / width);
  var sX = (image.width - sWidth) * offsetX;
  var sY = (image.height - sHeight) * offsetY;
  // Positionning values
  var tX = 0;
  var tY = 0;
  if (isHalfRotated) {
    tX = -width - x;
    tY = -height - y;
  } else if (isQuarterRotated) {
    tX = !isRotatedClockwise ? x : -height - x;
    tY = isRotatedClockwise ? y : -width - y;
  }
  var tWidth = !isQuarterRotated ? width : height;
  var tHeight = !isQuarterRotated ? height : width;
  // Draw image
  if (rotation) {
    ctx.rotate(rotation);
  }
  if (objectFit !== 'none') {
    ctx.drawImage(image, sX, sY, sWidth, sHeight, tX, tY, tWidth, tHeight);
  } else {
    ctx.drawImage(image, tX, tY, tWidth, tHeight);
  }
  if (rotation) {
    ctx.rotate(-rotation);
  }
};
//# sourceMappingURL=index.js.map